import { Box, Button, Stack } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo } from 'react';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface IProjectDeleteConfirmDialogProps {
  projectName: string;
  handleConfirm: () => void;
}

function ProjectDeleteConfirmDialog({
  projectName,
  handleConfirm,
}: IProjectDeleteConfirmDialogProps): JSX.Element {
  const dispatch = useAppDispatch();

  const handleCancel = () => {
    dispatch(closeDialog());
  };

  const handleDelete = () => {
    handleConfirm();
    dispatch(closeDialog());
  };

  return (
    <DialogContent width={{ desktop: 500 }} height={{ desktop: 'fit-content' }}>
      <DialogTitle hideCloseButton>프로젝트 삭제</DialogTitle>
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3, color: 'error.main' }}>
          경고: 프로젝트를 삭제하시겠습니까?
        </Box>
        <Box sx={{ fontSize: 16, mb: 3 }}>
          프로젝트명: <strong>{projectName}</strong>
        </Box>
        <Box sx={{ fontSize: 14, color: 'text.secondary' }}>
          이 작업은 되돌릴 수 없습니다. 프로젝트와 관련된 모든 데이터가 삭제됩니다.
        </Box>
      </DialogBody>
      <DialogButtons justifyContent="flex-end" marginTop="0px">
        <Stack direction="row" spacing={2} alignContent="center">
          <Button variant="outlined" color="inherit" onClick={handleCancel}>
            취소
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            삭제
          </Button>
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(ProjectDeleteConfirmDialog);


